import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const OpacityIcon = ({
  id = 'opacity-icon',
  color = '#E6E6E6',
  size = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    {...props}
  >
    <defs>
      <linearGradient id={id} x1="100%" x2="0%" y1="50%" y2="50%">
        <stop offset="0%" stopColor={color} />
        <stop offset="100%" stopColor="#798588" />
      </linearGradient>
    </defs>
    <path
      fill={`url(#${id})`}
      fillRule="evenodd"
      d="M4 16v4H0v-4zm8 0v4H8v-4zm8 0v4h-4v-4zM8 12v4H4v-4zm8 0v4h-4v-4zM4 8v4H0V8zm8 0v4H8V8zm8 0v4h-4V8zM8 4v4H4V4zm8 0v4h-4V4zM4 0v4H0V0zm8 0v4H8V0zm8 0v4h-4V0z"
    />
  </svg>
);

OpacityIcon.propTypes = propTypes;

export default OpacityIcon;
